import { render, staticRenderFns } from "./mobileWishlist.vue?vue&type=template&id=5cdd00c6&scoped=true"
import script from "./mobileWishlist.vue?vue&type=script&lang=js"
export * from "./mobileWishlist.vue?vue&type=script&lang=js"
import style0 from "./mobileWishlist.vue?vue&type=style&index=0&id=5cdd00c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd00c6",
  null
  
)

export default component.exports